import styled from 'styled-components';
import { Card } from 'antd';

export const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 24px;
`;

export const PageTitle = styled.h1`
  font-size: 32px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 32px;
`;

export const StyledCard = styled(Card)`
  margin-bottom: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .ant-card-body {
    padding: 0;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;

  h3 {
    margin: 0 0 0 12px;
    font-size: 18px;
    font-weight: 600;
    color: #2c3e50;
  }

  > div:first-child {
    display: flex;
    align-items: center;
  }
`;

export const CardContent = styled.div`
  padding: 24px;
`;

export const DeviceItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  margin-bottom: 12px;
  transition: all 0.3s;

  &:hover {
    background-color: #fafafa;
    border-color: #d9d9d9;
  }
`;

export const DeviceInfo = styled.div`
  flex: 1;

  h4 {
    margin: 0 0 8px 0;
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
  }
`;

export const DeviceMeta = styled.div`
  display: flex;
  gap: 8px;
  font-size: 13px;
  color: #999;

  span {
    &:not(:last-child):not(:nth-child(2n)) {
      margin-right: 8px;
    }
  }
`;
